import axiosClient from '../axiosClient';
import { TimeslotEndpoints } from '../endpoints/timeslots';
import { IGetAllTimeslotsResponse } from '../../types/api/response/timeslotresponse';
import { IUpdateTimeslotRequest } from '../../types/api/request/timeslotrequest';

export const TimeslotsService = {
  async getAllTimeslots(): Promise<IGetAllTimeslotsResponse> {
    const res = await axiosClient.get<IGetAllTimeslotsResponse>(
      TimeslotEndpoints.GET_ALL_TIMESLOTS,
    );
    return res.data;
  },

  async updateTimeslot(payload: IUpdateTimeslotRequest): Promise<void> {
    await axiosClient.post(TimeslotEndpoints.UPDATE_TIMESLOT, payload);
  },
};
